import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'transferOrdersBatch';
export const transferOrdersBatchActions = makeActions(
  MODEL_NAME,
  'id',
  'transfer-orders-batch',
);

export const getAllTransferOrdersBatch = transferOrdersBatchActions.getAll;
export const editTransferOrdersBatch = transferOrdersBatchActions.edit;
export const createTransferOrdersBatch = transferOrdersBatchActions.create;
export const getByIdTransferOrdersBatch =
  transferOrdersBatchActions.getDataById;
